import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer, { drawerClasses } from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import { useNavigate } from 'react-router-dom';
import { useSiteSession } from '../../context/SiteSessionContext';
import MenuButton from './MenuButton';
import MenuContent from './MenuContent';

export default function SideMenuMobile({ open, toggleDrawer }) {
  const navigate = useNavigate();
  const { isAdmin, site, disconnect } = useSiteSession();

  const handleDisconnect = () => {
    disconnect();
    toggleDrawer(false)();
    navigate('/connexion');
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={toggleDrawer(false)}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        [`& .${drawerClasses.paper}`]: {
          backgroundImage: 'none',
          backgroundColor: 'background.paper',
          width: { xs: '88vw', sm: 360 },
          maxWidth: 'calc(100vw - 24px)',
        },
      }}
    >
      <Stack sx={{ width: '100%', height: '100%' }}>
        <Stack direction="row" sx={{ p: 2, pb: 0, gap: 1 }}>
          <Stack direction="row" sx={{ gap: 1, alignItems: 'center', flexGrow: 1, p: 1, minWidth: 0 }}>
            <Box
              sx={{
                width: 30,
                height: 30,
                borderRadius: 1,
                display: 'grid',
                placeItems: 'center',
                bgcolor: 'rgba(255,255,255,0.94)',
                border: '1px solid',
                borderColor: 'divider',
                overflow: 'hidden',
                flexShrink: 0,
              }}
            >
              <Box
                component="img"
                src="/optibox-logo.svg"
                alt="Optibox"
                sx={{ width: 25, height: 25, objectFit: 'contain' }}
              />
            </Box>
            <Typography component="p" variant="subtitle1" sx={{ fontWeight: 850, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {isAdmin ? 'Administrateur' : site?.name || 'Site'}
            </Typography>
          </Stack>
          <MenuButton showBadge>
            <NotificationsRoundedIcon />
          </MenuButton>
        </Stack>
        <Divider />
        <Stack sx={{ flexGrow: 1, overflow: 'auto' }}>
          <MenuContent onNavigate={toggleDrawer(false)} />
          <Divider />
        </Stack>
        <Stack sx={{ p: 2 }}>
          <Button variant="outlined" fullWidth startIcon={<LogoutRoundedIcon />} onClick={handleDisconnect}>
            Déconnexion
          </Button>
        </Stack>
      </Stack>
    </Drawer>
  );
}
